import ReactDOM from 'react-dom';
import styles from "./Overlay.module.scss"


export const Overlay = (props) => {
    return ReactDOM.createPortal(
        <div className={styles.overlay} id='overlay' onClick={props.hideOverlay}>{props.children}</div>,
        document.getElementById("overlay"))
}